import { useParams } from 'react-router-dom';
import {
    Button, Center, Text, VStack,
} from '@chakra-ui/react';
import { AppLoader } from '../../../components/app-loader';
import { useViewOnlineServiceReport } from '../hooks/use-view-online-service-report';
import { DiLogo } from '../../../components/di-logo';

function ErrorScreen({ errorMessage }: { errorMessage: string }) {
    return (
        <Center w="100%" h="100vh">
            <VStack spacing={10}>
                <DiLogo variant="horizontalRGB" w="xs" />
                <VStack>
                    <Text fontSize="lg" fontWeight="medium" color="danger.500">
                        Unable to open service report
                    </Text>
                    <Text>{errorMessage}</Text>
                </VStack>
                <Button
                    onClick={() => window.close()}
                    variant="rounded-solid"
                    size="cta-md"
                    colorScheme="primary"
                >
                    Close this window
                </Button>
            </VStack>
        </Center>
    );
}

function ViewOnlineServiceReportPage({ serviceSheetId }: { serviceSheetId: number }) {
    // Redirects internally on success - only the error state matters here.
    const { isError, error } = useViewOnlineServiceReport(serviceSheetId);

    if (isError) {
        const errorMessage = error !== undefined
            ? error.message
            : 'Please try again, or contact support if this continues.';

        return <ErrorScreen errorMessage={errorMessage} />;
    }

    return <AppLoader loadingText="Opening your service report" />;
}

export function ViewOnlineServiceReport() {
    const { serviceSheetId } = useParams();
    const parsedServiceSheetId = Number(serviceSheetId);

    const isValid = serviceSheetId !== undefined
        && Number.isInteger(parsedServiceSheetId)
        && parsedServiceSheetId > 0;

    if (!isValid) {
        return <ErrorScreen errorMessage="This service report link is invalid." />;
    }

    return <ViewOnlineServiceReportPage serviceSheetId={parsedServiceSheetId} />;
}
